import OnClickOutside from "./on-click-outside.vue";
import { pluginify } from "./../../util";
export default pluginify(OnClickOutside);
export { OnClickOutside };
